import React from 'react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    text: 'Tenía plata parada en el banco desde hacía dos años. Con el método de las 3 cuentas organicé todo en un fin de semana. En 6 semanas armé mi fondo de emergencia y ejecuté mi primera inversión real.',
    author: 'Adrián M.',
    location: 'Buenos Aires'
  }, {
    text: 'Siempre creí que invertir era para gente con mucha plata. Empecé con lo que tenía y en 30 días ya tenía mis inversiones automatizadas. Vale cada peso.',
    author: 'Sara L.',
    location: 'Rosario'
  }, {
    text: 'El simulador de interés compuesto me dejó sin palabras. Ver en números lo que pierdo cada mes por no hacer nada me convenció en 30 segundos. Empecé esa misma noche.',
    author: 'Carlos F.',
    location: 'Córdoba'
  }];
  return <section className="bg-white text-navy py-16 px-4" data-id="element-228">
      <div className="max-w-[720px] mx-auto" data-id="element-229">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 leading-tight" data-id="element-230">
          Lo que dicen quienes ya empezaron a mover su plata
        </h2>

        <div className="flex flex-col gap-4" data-id="element-231">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-light p-6 rounded-2xl border border-navy/5 shadow-sm" data-id="element-232">
              <div className="text-gold mb-3 text-lg tracking-widest" data-id="element-233">
                ★★★★★
              </div>
              <p className="text-[15px] italic text-navy/80 mb-4 leading-[1.6]" data-id="element-234">
                "{review.text}"
              </p>
              <p className="text-sm font-bold text-navy" data-id="element-235">
                — {review.author}{' '}
                <span className="text-navy/50 font-normal" data-id="element-236">
                  · {review.location}
                </span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}